import { render, staticRenderFns } from "./creditos.vue?vue&type=template&id=241b7202&"
import script from "./creditos.vue?vue&type=script&lang=js&"
export * from "./creditos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports